import { SVGProps } from "react";

export default function StepIcon5(props: SVGProps<SVGSVGElement>) {
  return (
<svg {...props} width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.6043 8.125V7.1875C16.6043 5.6342 15.3923 4.375 13.8973 4.375H11.1026C10.621 4.375 10.1481 4.2415 9.73266 3.98827L7.92573 2.88673C7.51034 2.6335 7.03743 2.5 6.55581 2.5H4.87398C3.37895 2.5 2.16699 3.7592 2.16699 5.3125V14.6875C2.16699 16.2408 3.37895 17.5 4.87398 17.5H12.756C14.0239 17.5 15.1987 16.8089 15.851 15.6794L18.5737 10.9647C19.2954 9.71495 18.429 8.125 17.0262 8.125H16.6043ZM16.6043 8.125H9.02424C7.59788 8.125 6.3053 8.99775 5.726 10.352L3.06932 16.5625" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
 );
};
